import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Col, Row, Form, Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { Content } from '../styles';
import ModalKonfirmasi from '../../../../components/ModalKonfirmasi';
import config from '../../../../config';

const FormBuat = (props) => {
  const formData = new FormData();
  const today = new Date();
  const [poster, setPoster] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [state, setState] = useState({
    nama_kegiatan: '',
    jenis_kegiatan: 'kuliah umum',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    nilai_kum: '',
    biaya: '',
    sertifikat: '',
    link_regis: 'https://',
    lokasi: '',
    pembicara: '',
    moderator: '',
    poster: '',
  });
  const [error, setError] = useState('');

  const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

  const FILESIZE = 10485760;

  const handleImageChange = (e) => {
    setPoster({
      image: e.target.files[0],
    });
  };

  const inputChange = (e, input) => {
    let ubah = e.target.value;
    if (input === 'link_regis') {
      if (ubah.length <= 8) {
        ubah = 'https://';
      } else if (!e.target.value.startsWith('https://')) {
        ubah = `https://${e.target.value}`;
      }
    }
    setState({
      ...state,
      [input]: ubah,
    });
  };

  const formik = useFormik({
    initialValues: {
      nama_kegiatan: '',
      jenis_kegiatan: 'kuliah umum',
      tanggal: '',
      pukul: '',
      penyelenggara: '',
      nilai_kum: '',
      biaya: '',
      sertifikat: '',
      link_regis: 'https://',
      lokasi: '',
      pembicara: '',
      moderator: '',
      poster: '',
    },
    validationSchema: Yup.object({
      nama_kegiatan: Yup.string().required('Nama Kegiatan harus diisi!'),
      jenis_kegiatan: Yup.string().required('Required!'),
      tanggal: Yup.date().min(today, 'Harus waktu di masa yang akan datang!'),
      penyelenggara: Yup.string().required('Penyelenggara harus diisi!'),
      nilai_kum: Yup.number().min(0, 'Nilai KUM tidak boleh negatif'),
      sertifikat: Yup.string().required('Keterangan sertifikat harus diisi!'),
      lokasi: Yup.string().required('Lokasi harus diisi!'),
      pembicara: Yup.string().required('Pembicara harus diisi!'),
      biaya: Yup.number().min(0, 'Biaya tidak boleh negatif!'),
    }),
    onSubmit: () => {
      formData.append('nama_kegiatan', state.nama_kegiatan);
      formData.append('jenis_kegiatan', state.jenis_kegiatan);
      formData.append('tanggal', state.tanggal);
      formData.append('pukul', state.pukul);
      formData.append('penyelenggara', state.penyelenggara);
      formData.append('nilai_kum', parseFloat(state.nilai_kum).toFixed(1));
      if (state.biaya !== '' && state.biaya != null) {
        formData.append('biaya', parseInt(state.biaya, 10));
      }
      formData.append('sertifikat', state.sertifikat);
      if (state.link_regis !== '' && state.link_regis !== undefined) {
        formData.append('link_regis', state.link_regis);
      }
      formData.append('lokasi', state.lokasi);
      formData.append('pembicara', state.pembicara);
      if (state.moderator !== '' && state.moderator !== undefined) {
        formData.append('moderator', state.moderator);
      }
      formData.append('poster', poster.image, poster.image.name);
      axios.post(`${config.API_BASE_URL}api/kuliah_umum/`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then(
        () => (
          props.history.push('/')
        ),
      );
    },
  });

  const handleSubmit1 = () => {
    let errorText = error;
    if (poster) {
      const value = poster.image;
      if (!SUPPORTED_FORMATS.includes(value.type)) {
        errorText = 'Poster harus berupa gambar!';
      } else if (value.size > FILESIZE) {
        errorText = 'Maksimum ukuran poster 10 MB!';
      } else {
        errorText = '';
      }
    } else {
      errorText = 'Poster harus ada!';
    }

    if (errorText === '') {
      formik.handleSubmit();
    } else {
      setError(errorText);
    }
    setModalShow(false);
  };

  return (
    <Content>
      <Form>
        <h1 className="mb-4">Selamat Datang di Menambah Informasi Kuliah Umum</h1>
        <h1 className="mb-5">Data Kegiatan</h1>
        <Form.Group as={Row} controlId="formPlaintextNamaKegiatan">
          <Form.Label column sm="2">
            <p>
              Nama Kegiatan
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control
              type="text"
              id="form1"
              placeholder="Kuliah Umum Ekonomi"
              name="nama_kegiatan"
              data-testid="nama_kegiatan"
              onChange={(e) => { formik.handleChange(e); inputChange(e, 'nama_kegiatan'); }}
              value={state.nama_kegiatan}
            />
            {formik.errors.nama_kegiatan && formik.touched.nama_kegiatan && (
            <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.nama_kegiatan}</div>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextJenisKegiatan">
          <Form.Label column sm="2">
            <p>
              Jenis Kegiatan
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" as="select" data-testid="jenis_kegiatan" name="jenis_kegiatan" className="jenis_kegiatan" onChange={(e) => { formik.handleChange(e); inputChange(e, 'jenis_kegiatan'); }} value={state.jenis_kegiatan}>
              <option value="kuliah umum">kuliah umum</option>
              <option value="seminar ilmiah">seminar ilmiah</option>
            </Form.Control>
            {formik.errors.jenis_kegiatan && formik.touched.jenis_kegiatan && (
            <div className="text-danger">{formik.errors.jenis_kegiatan}</div>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextHariTanggal">
          <Form.Label column sm="2">
            <p>
              Hari/Tanggal
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="date" className="tanggal" name="tanggal" data-testid="tanggal" onChange={(e) => { formik.handleChange(e); inputChange(e, 'tanggal'); }} value={state.tanggal} />
            {formik.errors.tanggal && formik.touched.tanggal && (
            <div className="text-danger">{formik.errors.tanggal}</div>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextPukul">
          <Form.Label column sm="2">
            <p>
              Pukul
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="time" data-testid="pukul" className="pukul" name="pukul" onChange={(e) => { formik.handleChange(e); inputChange(e, 'pukul'); }} value={state.pukul} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextPenyelenggara">
          <Form.Label column sm="2">
            <p>
              Penyelenggara
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" className="penyelenggara" name="penyelenggara" data-testid="penyelenggara" placeholder="BEM FEB UI" onChange={(e) => { formik.handleChange(e); inputChange(e, 'penyelenggara'); }} value={state.penyelenggara} />
            {formik.errors.penyelenggara && formik.touched.penyelenggara && (
            <div className="text-danger">{formik.errors.penyelenggara}</div>
            )}
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextNilaiKUM">
          <Form.Label column sm="2">
            <p>
              Nilai KUM
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control step="0.1" min="0" max="9.9" data-testid="nilai_kum" type="number" className="nilai_kum" name="nilai_kum" onChange={(e) => { formik.handleChange(e); inputChange(e, 'nilai_kum'); }} value={state.nilai_kum} />
            {formik.errors.nilai_kum && formik.touched.nilai_kum && (
            <div className="text-danger">{formik.errors.nilai_kum}</div>
            )}
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextBiaya">
          <Form.Label column sm="2">
            <p>Biaya (Dalam Rupiah)</p>
          </Form.Label>
          <Col sm="10">
            <Form.Control min="0" type="number" data-testid="biaya" className="biaya" name="biaya" onChange={(e) => { formik.handleChange(e); inputChange(e, 'biaya'); }} value={state.biaya} />
          </Col>
          {formik.errors.biaya && formik.touched.biaya && (
            <div className="text-danger">{formik.errors.biaya}</div>
          )}
        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextSertifikat">
          <Form.Label column sm="2">
            <p>
              Sertifikat
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" as="select" data-testid="sertifikat" className="sertifikat" name="sertifikat" placeholder="Ya (Sertifikat Elektronik)" onChange={(e) => { formik.handleChange(e); inputChange(e, 'sertifikat'); }} value={state.sertifikat}>
              <option value="Ya (Tersedia)">Ya (Tersedia)</option>
              <option value="Ya (Berbayar)">Ya (Berbayar)</option>
              <option value="Tidak Tersedia">Tidak Tersedia</option>
            </Form.Control>
            {formik.errors.sertifikat && formik.touched.sertifikat && (
            <div className="text-danger">{formik.errors.sertifikat}</div>
            )}
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextLinkRegistrasi">
          <Form.Label column sm="2">
            <p>Link Registrasi</p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" data-testid="link_regis" className="link_regis" name="link_regis" placeholder="s.id/daftarKUM" onChange={(e) => { formik.handleChange(e); inputChange(e, 'link_regis'); }} value={state.link_regis} />
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlaintextLokasi">
          <Form.Label column sm="2">
            <p>
              Lokasi
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" data-testid="lokasi" className="lokasi" name="lokasi" placeholder="Balairung UI" onChange={(e) => { formik.handleChange(e); inputChange(e, 'lokasi'); }} value={state.lokasi} />
            {formik.errors.lokasi && formik.touched.lokasi && (
            <div className="text-danger">{formik.errors.lokasi}</div>
            )}
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlainTextPembicara">
          <Form.Label column sm="2">
            <p>
              Pembicara
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" data-testid="pembicara" className="pembicara" name="pembicara" placeholder="Fathurizki Luthfi Azzahra" onChange={(e) => { formik.handleChange(e); inputChange(e, 'pembicara'); }} value={state.pembicara} />
            {formik.errors.pembicara && formik.touched.pembicara && (
            <div className="text-danger">{formik.errors.pembicara}</div>
            )}
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="formPlainTextPembicara">
          <Form.Label column sm="2">
            <p>Moderator</p>
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" data-testid="moderator" className="moderator" name="moderator" placeholder="Talitha Luthfi" onChange={(e) => { formik.handleChange(e); inputChange(e, 'moderator'); }} value={state.moderator} />
          </Col>

        </Form.Group>

        <Form.Group as={Row} controlId="forminputPoster">
          <Form.Label column sm="2">
            <p>
              Upload Poster
              <span style={{ color: 'red' }}>*</span>
            </p>
          </Form.Label>
          <Col sm="10">
            <Form.Control
              type="file"
              className="poster-uploader"
              data-testid="poster"
              accept="image/png, image/jpeg"
              onChange={(e) => { formik.handleChange(e); handleImageChange(e); }}
            />
          </Col>
        </Form.Group>
        {error !== '' && (
          <div data-testid="poster_error" className="text-danger">{error}</div>
        )}

        <Col className="col-12 text-right buttonKanan">
          <Link to="/">
            <Button className="btnCancel btn-primary mr-2" variant="danger">Batal</Button>
          </Link>
          <Button className="btnKirim btn-primary" variant="success" onClick={() => setModalShow(true)}>Kirim</Button>
        </Col>
        <ModalKonfirmasi
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSubmit={handleSubmit1}
        />
      </Form>
    </Content>
  );
};

FormBuat.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(FormBuat);
